
<div class="kyo_container">
    <ng-container *ngIf="powerBiCred != null">
        <powerbi-report
        [embedConfig] = "powerBiCred"
        [cssClassName] = "'report-kyo'"
        [eventHandlers] ="handlers"
        >
        </powerbi-report>
    </ng-container>
</div>

